document.addEventListener('DOMContentLoaded', function() {
  var menuBtn = document.getElementById('WbMobileMenu');
  var mobileMenu = document.getElementById('WbxsMenu');
  
  if (menuBtn && mobileMenu) {
    menuBtn.addEventListener('click', function() {
      if (mobileMenu.style.display === 'block') {
        mobileMenu.style.display = 'none';
      } else {
        mobileMenu.style.display = 'block';
      }
    });
  }
});